import React, { useEffect } from 'react';
import calculateQuotation from '../../../calculateQuotation';

const InquiryPrint = ({ object, onReady }) => {
  useEffect(() => {
    if (object && typeof onReady === 'function') {
      const timeout = setTimeout(() => {
        onReady()
      }, 50)
      return () => clearTimeout(timeout)
    }
  }, [object, onReady])

  if (!object) return null;

  const quotation = calculateQuotation(object)

  const formatDate = object?.updated
    ? new Date(object.updated).toLocaleDateString(undefined, {
      month: 'long',
      year: 'numeric'
    })
    : 'N/A'
    
  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif', fontSize: '14px', color: '#000' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
        {object.logo && (
          <img 
            src={object.logo}
            alt="Logo 1"
            style={{ height: '60px', objectFit: 'contain' }}
          />
        )}
        <div style={{ textAlign: 'center', flexGrow: 1 }}>
          <h1 style={{ margin: 0 }}>SAMPLE COMPUTATION</h1>
          <h2 style={{ margin: 0 }}>{(object.client.first_name.toUpperCase())} {(object.client.last_name.toUpperCase())}</h2>
          <h4 style={{ margin: '5px 0' }}>{formatDate}</h4>
        </div>
        {object.second_logo && (
          <img 
            src={object.second_logo}
            alt="Logo 2"
            style={{ height: '60px', objectFit: 'contain' }}
          />
        )}
      </div>

      <div style={{ backgroundColor: '#2b2e83', color: '#fff', padding: '8px', textAlign: 'center', fontWeight: 'bold', marginBottom: '20px' }}>
        Payment Term: {object.payment_term}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
        <div><strong>Unit Type</strong></div>
        <div><strong>{object.unit_type}</strong></div>

        <div><strong>Unit</strong></div>
        <div><strong>{object.unit}</strong></div>

        <div><strong>Unit View</strong></div>
        <div>{object.unit_view}</div>

        <div>Floor Area (in SQM)</div>
        <div>{quotation.formatNum(object.floor_area)}</div>

        <div>Balcony (in SQM)</div>
        <div>{object.balcony ? quotation.formatNum(object.balcony) : '-'}</div>

        <div><strong>Gross Floor Area</strong></div>
        <div>{quotation.formatNum(quotation.grossFloorArea)}</div>

        <div>Gross Unit Price</div>
        <div> {quotation.formatNum(object.gross_unit_price)}</div>

        <div>Less: {object.unit_type_discount ? `${object.unit_type_discount}%` : ''} Unit Type Discount</div>
        <div>{quotation.unitTypeDiscount ? quotation.formatNum(quotation.unitTypeDiscount) : ''}</div>

        <div>Net of Unit Type Discount</div>
        <div> {quotation.formatNum(quotation.netOfUnitTypeDiscount)}</div>

        <div>Less: {object.launch_discount ? `${object.launch_discount}%` : ''} Launch Discount</div>
        <div>({quotation.formatNum(quotation.launchDiscountValue)})</div>

        <div><strong>Net Total Contract Price</strong></div>
        <div><strong>{quotation.formatNum(quotation.totalContractPrice)}</strong></div>

        <div>Price per SQM</div>
        <div> {quotation.formatNum(quotation.pricePerSQM)}</div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#eee', padding: '2px 8px', marginRight: '8px' }}>
            <strong>{object.equity ? `${object.equity}%` : ''}</strong>
          </div>
          Equity
        </div>
        <div> {quotation.formatNum(quotation.equityValue)}</div>

        <div>Less: Reservation Fee (RF)</div>
        <div><strong>({quotation.formatNum(object.reservation_fee)})</strong></div>

        <div>Total Equity Net of RF</div>
        <div> {quotation.formatNum(quotation.totalEquityNetofRF)}</div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#eee', padding: '2px 8px', marginRight: '8px', fontWeight: 'bold' }}>
            {object.monthly_amortization}
          </div>
          <strong>Monthly Amortizations</strong>
        </div>
        <div><strong> {quotation.formatNum(quotation.monthlyAmortization)}</strong></div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#eee', padding: '2px 8px', marginRight: '8px', fontWeight: 'bold' }}>
            {object.retention ? `${object.retention}%` : ''}
          </div>
            Retention
        </div>
        <div> <strong>{quotation.formatNum(quotation.retentionValue)}</strong></div>

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <div style={{ backgroundColor: '#eee', padding: '2px 8px', marginRight: '8px', fontWeight: 'bold' }}>
            {object.closing_fee ? `${object.closing_fee}%` : ''}
          </div>
            Closing Fee*
        </div>
        <div> <strong>{quotation.formatNum(quotation.closingFeeValue)}</strong></div>
      </div>
    </div>
  );
};

export default InquiryPrint;
